export const getEnv = (name) => {
    if (window && window._env_ && name in window._env_) {
        return window._env_[name];
    } else {
        return process.env[name];
    }
};

export default {
    getEnv
};
